import React from "react";
import toast from "react-hot-toast";
import { toAbsoluteUrl } from "../../helpers";

export interface UserAttemptAccessNotification {
  user: {
    companyId: number;
    userId: number;
    fullName: string;
    profileImage: string;
    braceletId: number;
    braceletColorId: number;
    braceletColorName: string;
    braceletColor: string;
    braceletMaster: boolean;
    sectionId: number;
    sectionDescription: string;
    originSectionDescription: string | null;
    destinationSectionDescription: string | null;
    enteringSection: boolean;
  };
}

export function accessNotificationToast(
  accessNotification: UserAttemptAccessNotification,
  isAttemptAccessNotification: boolean = false,
  isAccessNotification: boolean = false,
  isGiveUpAccessNotification: boolean = false
) {
  const pathUrl = "https://companies-admin.aacceson.com/";

  const imageSrc = accessNotification.user.profileImage
    ? `${pathUrl}${accessNotification.user.profileImage}`
    : toAbsoluteUrl("/media/avatars/blank.png");

  const isUserGoingToOutside =
    isAccessNotification &&
    !accessNotification.user.enteringSection &&
    ![accessNotification.user.originSectionDescription].includes(null) &&
    [accessNotification.user.destinationSectionDescription].includes(null);

  const textUserGoingToOutside = isUserGoingToOutside
    ? `Saiu do clube, estava na seção ${accessNotification.user.originSectionDescription}.`
    : "";

  const notificationText = isAttemptAccessNotification
    ? "Apresentou a pulseira e está tentando "
    : isGiveUpAccessNotification
    ? "Desistiu de "
    : "";

  const operationAttemptAccess = accessNotification.user.braceletMaster
    ? "entrar ou sair da"
    : accessNotification.user.enteringSection
    ? "entrar na"
    : "sair da";

  const isAccessNotificationAndBraceletMaster =
    isAccessNotification && accessNotification.user.braceletMaster;

  const operationAccess = isAccessNotificationAndBraceletMaster
    ? "Entrou ou saiu da"
    : accessNotification.user.enteringSection
    ? "Entrou na"
    : "Saiu da";

  const exitEnteringAnotherSection =
    isAccessNotification &&
    !accessNotification.user.enteringSection &&
    ![accessNotification.user.originSectionDescription].includes(null) &&
    ![accessNotification.user.destinationSectionDescription].includes(null)
      ? ` e entrou na seção ${accessNotification.user.destinationSectionDescription}`
      : ``;

  return toast((t) => (
    <div
      style={{ height: 65, width: "100vw" }}
      className={`${t.visible ? "animate-enter" : "animate-leave"} `}
    >
      <div className="d-inline-block">
        <div>
          <img
            className="w-55px h-55px rounded-circle zoom-in"
            src={imageSrc}
            alt="profile_image_notification"
          />
        </div>
      </div>

      <div className="position-absolute d-inline-block" style={{ left: "25%" }}>
        <div className="user-name">
          <p className="fw-bolder">{accessNotification?.user?.fullName}</p>
        </div>
        <div className="message text-gray-500">
          <p>
            {isUserGoingToOutside
              ? textUserGoingToOutside
              : `${notificationText} ${
                  isAttemptAccessNotification || isGiveUpAccessNotification
                    ? operationAttemptAccess
                    : operationAccess
                } seção ${
                  accessNotification?.user?.sectionDescription
                }${exitEnteringAnotherSection}!`}
          </p>
        </div>
      </div>

      <div className="position-absolute d-inline border-l border-gray-200 top-0 end-0">
        <button
          style={{ backgroundColor: "white", margin: 10 }}
          onClick={() => toast.dismiss(t.id)}
          className="border border-transparent rounded-none"
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  ));
}
